import { useRef } from "react";
import { useMutation } from "@tanstack/react-query";
import { NotificationsLevel } from "../../../lib/enums";
import { show } from "../../../notifications/notifications";
import api from "../services/api";

const useRescan = () => {
  const scanData = useRef({
    submittedForRescan: null,
    isSubmitStatusFetched: false
  });

  const { mutateAsync: sampleStatus } = useMutation({
    mutationFn: api.rescanSampleStatus,
    onSuccess: ({ data }) => {
      scanData.current = {
        submittedForRescan: data.submitted,
        isSubmitStatusFetched: true
      };
    },
    onError: () => {
      scanData.current = {
        submittedForRescan: null,
        isSubmitStatusFetched: true
      };
    }
  });

  const { mutate: rescan } = useMutation({
    mutationFn: api.rescanSample,
    onSuccess: ({ data }) => {
      scanData.current.submittedForRescan = data.submitted;
      show({
        level: NotificationsLevel.SUCCESS,
        message: "Successfully submitted the sample for rescan."
      });
    },
    onError: () => {
      show({
        level: NotificationsLevel.ERROR,
        message:
          "An error occurred attempting to submit the sample for rescan. Please try again or contact support."
      });
    }
  });

  return { rescan, sampleStatus, scanData };
};

export default useRescan;
